import { Navigate, Route, Routes } from "react-router-dom";

import { NoAccess, SubNav } from "@/app/Shell";
import { CAP, useSession } from "@/auth/session";
import { FotaDebugPage } from "@/modules/fota/DebugPage";
import { FotaOverviewPage } from "@/modules/fota/OverviewPage";
import { FotaFirmwarePage } from "@/modules/fota/FirmwarePage";
import { FotaUpdatePage } from "@/modules/fota/UpdatePage";

/** FOTA module.
 *
 *  FOUR TABS, THREE OF THEM GATED. Gate 200 says you may open FOTA; it does not
 *  say you may publish firmware, run a rollout or drive the device simulator.
 *  Before D-77 that distinction did not matter, because only a super admin held
 *  gate 200 at all — the PLAN x ROLE matrix now grants it to company_admin and
 *  company_user on every tier, so an ungated tab is a page whose every button
 *  returns 403.
 *
 *    Overview   ungated — your fleet's version histogram, scoped server-side
 *    Firmware   PUBLISH_FIRMWARE, internal-only: builds are Aphelion's artefacts
 *    Update     RUN_BATCHES, a Pro feature
 *    Debug      FOTA_DEBUG, internal-only bench tooling
 *
 *  Hiding a tab is UX. `require_cap` on each route is the enforcement, and the
 *  route guards below are what stop a typed URL reaching the page anyway.
 */
export function FotaModule() {
  const { can } = useSession();
  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-end" }}>
        <SubNav
          base="/fota"
          tabs={[
            { path: "overview", label: "Overview" },
            { path: "firmware", label: "Firmware", gate: CAP.PUBLISH_FIRMWARE },
            { path: "update", label: "Update", gate: CAP.RUN_BATCHES },
            { path: "debug", label: "Debug", gate: CAP.FOTA_DEBUG },
          ]}
        />
        <div style={{ marginLeft: "auto", paddingBottom: 9, paddingRight: 20 }}>
        </div>
      </div>
      <Routes>
        <Route path="overview" element={<FotaOverviewPage />} />
        <Route path="firmware" element={
          can(CAP.PUBLISH_FIRMWARE) ? <FotaFirmwarePage /> : <NoAccess label="firmware" />} />
        <Route path="update" element={
          can(CAP.RUN_BATCHES) ? <FotaUpdatePage /> : <NoAccess label="rollouts" />} />
        <Route path="debug" element={
          can(CAP.FOTA_DEBUG) ? <FotaDebugPage /> : <NoAccess label="FOTA debug" />} />
        <Route path="*" element={<Navigate to="overview" replace />} />
      </Routes>
    </>
  );
}
